import React from "react";

const LoadingIndicator = ({ 
  show = true, 
  size = "md",
  message = "Loading",
  position = "center"
}) => {
  if (!show) {
    return null;
  }

  const sizes = {
    sm: "w-4 h-4 border-2",
    md: "w-6 h-6 border-2",
    lg: "w-8 h-8 border-3",
  };

  const positions = {
    "top-left": "top-4 left-4",
    "top-right": "top-4 right-4",
    "bottom-left": "bottom-4 left-4",
    "bottom-right": "bottom-4 right-4",
    "center": "top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
  };

  const indicatorSize = sizes[size] || sizes["md"];
  const indicatorPosition = positions[position] || positions["bottom-right"];

  return (
    <div
      className={`fixed ${indicatorPosition} z-50 flex items-center space-x-3 p-2 pl-4 pr-6 rounded-lg
                 bg-white dark:bg-gray-800 backdrop-blur-sm bg-opacity-95
                 border border-gray-200 dark:border-gray-700
                 text-gray-900 dark:text-white 
                 shadow-lg hover:shadow-xl
                 transition-all duration-300 ease-out
                 animate-fade-in-up`}
      role="status"
      aria-live="polite"
    >
      {/* Modern spinner with gradient */}
      <div className="relative">
        <div
          className={`
            ${indicatorSize} 
            rounded-full 
            border-solid 
            border-gray-200 dark:border-gray-700
            border-t-transparent
            animate-spin
          `}
          style={{ 
            background: "conic-gradient(from 0deg, transparent, transparent 45deg, #06b6d4 45deg, #06b6d4 300deg, transparent 300deg)",
            animationDuration: "1.2s"
          }}
        />
        
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/1 w-1 h-1 bg-cyan-500 rounded-full opacity-80"></div>
      </div>

      {/* Text with better typography */}
      <div className="flex flex-col">
        <span className="text-lg font-medium tracking-tight text-gray-700 dark:text-gray-300">
          {message}
        </span>
        <span className="text-xs text-gray-500 dark:text-gray-400 font-normal mt-0.5">
          Please wait...
        </span>
      </div>
    </div>
  );
};

export default LoadingIndicator;